export const zh = {
    close: '关闭',
    cancellation:"作废",
    withdraw: '撤回',
    release: '发布',
    back: '返回',
    search: '查询',
    clean: '清空',
    reset: '重置',
    addNew: '新增',
    addNewRow: '新增行',
    del: '删除',
    delRow: '删除行',
    edit: '编辑',
    create: '创建',
    sel: '请选择',
    remove: '移除',
    cancel: '取消',
    confirm: '确定',
    save: '保存',
    all: '所有',
    have: '有',
    select: '选择',
    signOut: '退出',
    submit: '提交',
    return: '退回',
    audit: '审核',
    index: '序号',
    updateSuccess: '修改成功',
    updateError: '修改失败',
    closeSuccess: '关闭成功',
    closeError: '关闭失败',
    saveSuccess: '保存成功',
    auditSuccess: '审核成功',
    saveError: '保存失败',
    add: '添加',
    addSuccess: '添加成功',
    addError: '添加失败',
    delSuccess: '删除成功',
    disableSuccess: '禁用成功',
    delError: '删除失败',
    disableError: '禁用失败',
    exportSuccess: '导出成功',
    exportError: '导出失败',
    createSuccess: '创建成功',
    createError: '创建失败',
    submitSuccess: '提交成功',
    submitError: '提交失败',
    operateSuccess: '操作成功',
    operateError: '操作失败',
    startDate: '开始日期',
    endDate: '结束日期',
    selDate: '选择日期',
    currentLocation: '您当前的位置',
    operation: '操作',
    delWarning: '请注意：数据删除后不可恢复，是否继续操作？',
    disableWarning: '请注意：数据禁用后不可使用，是否继续操作？',
    tips: '提示',
    createBy: '创建人',
    rounds:"轮次",
    createDate: '创建日期',
    createTime: '创建时间',
    updateBy: '修改人',
    updateDate: '修改日期',
    status: '状态',
    details: '详情',
    template: '模版',
    templateDownload:"导入模板下载",
    attachment: '附件',
    bulkDownload: '批量下载',
    note:"备注/主题",
    remarks: '备注',
    selectFile: '选择文件',
    file: '文件',
    delConfirm: '请确认是否删除!',
    submitConfirm: '请确认是否提交!',
    returnConfirm: '请确认是否退回!',
    closeConfirm: '请确认是否作废!',
    suspendConfirm: '请确认是否中止!',
    copyConfirm: '请确认是否复制创建!',
    fileUploadFailed: '文件上传失败',
    quote: '报价',
    upload: '上传',
    pleaseSelectOneData: "请选择一条数据",
    pleaseSelectData: "请选择数据",
    pass: '通过',
    noPass: '不通过',
    reject: '驳回',
    stop: '中止',
    copy: '复制创建',
    copyLine: '复制行',
    copySuccess: '复制成功',
    canNotBeEmpty: '不能为空',
    numError: '请输入有效数字',
    priceError: '请输入最多6位小数',
    canNotBeEmpty0: '{0}不能为空',
    pleaseSelect: '请选择',
    yes: '是',
    no: '否',
    doesNotExist: '不存在',
    OperationTime: '操作时间',
    OperatorName: '操作人',
    PedagogicalOperation: '操作描述',
    description: "描述",
    ModifyContent: "修改内容",
    send: '发送',
    export: '导出',
    approvalLog: '审批日志',
    message: '消息',
    success: '成功',
    splitBy: '{split}分割',
    opinion: '处理意见',
    ApprovalPass: '审批通过',
    ApprovalReject: '审批拒绝',
    to: '至',
    noPermission: '没有该操作的权限',
    onlyOperateOwn: '只能操作自己名下的单据',
    Deselected: '取消选择',
    sureSubmit: '是否确认提交',
    Reenter: '请重新输入',
    Voided: '已经作废',
    name: '名称',
    TaskCreationTime: '待办任务创建时间',
    UploadSucceed: '上传成功',
    newBuilt: '新建',
    otherAttachments: '其他附件',
    approvalTime: '审批时间',
    approvalResults: '审批结果',
    approvalRemarks: '修改建议',
    contactNumber: '联系电话',
    download: '下载',
    PleaseSaveBeforeSubmitting: '请您先保存后在提交！',
    emailError: '输入正确的邮箱地址',
    RevisionComments: '修改意见',
    toReview: '复核',
    saveDraft: '保存为草稿',
    reviewer: '复核人',
    reviewTime: '复核时间',
    reviewOperationWindow: '复核操作窗口',
    PleaseRequired: '请填写必填的数据',
    uploadFile: '请上传附件',
    see: '查看',
    import: '导入'


}

export const en = {
    close: 'Close',
    cancellation:"作废",
    templateDownload:"导入模板下载",
    back: 'Back',
    search: 'Search',
    clean: 'Clean',
    reset: 'Reset',
    del: 'Delete',
    addNewRow: 'New row',
    delRow: 'Delete row',
    addNew: 'Add',
    edit: 'Edit',
    create: 'Add',
    sel: 'Please select',
    selLanguage: 'Please select language',
    remove: 'Remove',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    all: 'All',
    select: 'select',
    signOut: 'Sign out',
    submit: 'Submit',
    return: 'Return',
    audit: 'Audit',
    index: 'Index',
    updateSuccess: 'Update success',
    updateError: 'Update error',
    closeSuccess: 'Close success',
    closeError: 'Close error',
    saveSuccess: 'Save success',
    auditSuccess: 'Audit Success',
    saveError: 'Save error',
    add: 'Add',
    copyLine: 'Copy Line',
    addSuccess: 'Add Success',
    addError: 'Add error',
    delSuccess: 'Delete success',
    disableSuccess: 'Forbidden success',
    delError: 'Delete error',
    disableError: 'Forbidden error',
    exportSuccess: 'Export Success',
    exportError: 'Export error',
    createSuccess: 'Create success',
    createError: 'Create error',
    submitSuccess: 'Submit success',
    submitError: 'Submit error',
    operateSuccess: 'Operate Success',
    operateError: 'Operate Error',
    startDate: 'Start date',
    endDate: 'End date',
    selDate: 'Select date',
    currentLocation: 'Your current location',
    delWarning: 'Please note: data cannot be recovered after deletion. Do you want to continue?',
    disableWarning: 'Please note: data cannot be used after forbidden. Do you want to continue?',
    tips: 'Tips',
    createBy: 'Creator',
    rounds:"轮次",
    createDate: 'Create date',
    createTime: 'Create time',
    updateBy: 'Modified By',
    updateDate: 'Modified date',
    status: 'Status',
    details: 'details',
    attachment: 'Attachment',
    remarks: 'Remarks',
    note:"Remarks",
    selectFile: 'Select file',
    file: 'File',
    splitBy: 'split by {split}',
    delConfirm: 'Please confirm whether to delete!',
    submitConfirm: 'Please confirm whether to submit!',
    returnConfirm: 'Please confirm whether to return!',
    closeConfirm: 'Please confirm whether to close!',
    suspendConfirm: 'Please confirm whether to suspend!',
    copyConfirm: 'Please confirm whether to copy!',
    fileUploadFailed: 'File upload failed',
    quote: 'Quote',
    upload: 'Upload',
    pleaseSelectOneData: "Please select one data",
    pleaseSelectData: "Please select data",
    pass: 'Approve',
    reject: 'Reject',
    stop: 'Stop',
    copy: 'Copy',
    copySuccess: 'Copy Success',
    canNotBeEmpty: 'Can Not Be Empty',
    canNotBeEmpty0: '{0} Can Not Be Empty',
    pleaseSelect: 'Please Select ',
    yes: 'Yes',
    no: 'No',
    doesNotExist: ' Does Not Exist',
    OperationTime: 'Operation time',
    OperatorName: 'Operator name',
    PedagogicalOperation: 'Pedagogical Operation',
    operation: 'Operation',
    description: "Description",
    ModifyContent: "Modify content",
    send: 'Send',
    export: 'Export',
    approvalLog: 'Approval Log',
    message: 'Message',
    success: 'Success',
    opinion: 'Handle Opinion',
    ApprovalPass: 'Approval Pass',
    noPass: 'No Pass',
    ApprovalReject: 'Approval Reject',
    to: 'to',
    noPermission: 'No permission for this operation',
    onlyOperateOwn: 'You can only operate documents under your own name',
    Deselected: 'Deselected',
    sureSubmit: 'Confirm to submit',
    Reenter: 'Reenter',
    Voided: 'Voided',
    name: 'Name',
    TaskCreationTime: 'Task creation time',
    UploadSucceed: 'Upload succeed',
    newBuilt: 'newBuilt',
    otherAttachments: 'Qther Attachments',
    approvalTime: 'Approval Time',
    approvalResults: 'Approval Results',
    approvalRemarks: 'Approval Remarks',
    contactNumber: 'contact Number',
    download: 'download',
    emailError: 'Enter the correct email address',
    RevisionComments: 'revisions suggestion',
    toReview: 'to Review',
    import: 'Import',
    saveDraft: 'save as draft',
}